import { LOADER } from "./app";
import loadPicture from './loadPicture';

const changeScreenSrc = (screen, srcOptions) => {
  const { path, page, section, index } = srcOptions;

  const loader = screen.querySelector('.u_loader_wrap');
  if (!loader) screen.innerHTML += LOADER;

  const screenImgTag = screen.querySelector('img');
  const screenSrcTag = screen.querySelector('source');

  setTimeout(() => {
    loadPicture(screenImgTag, screenSrcTag, `${path}/${page}/${section}/${index}@2x`)
      .then(() => screen.querySelector('.u_loader_wrap')?.remove())
      .catch(() => {
        screen.querySelector('.u_loader_wrap')?.remove();
        console.warn('Image failed to load');
      });
  }, 500);
};

export default changeScreenSrc;
